import { Avatar, AvatarImage } from "@/components/ui/avatar";

export function WorkstationLoading() {
  return (
    <div className="flex items-start gap-3 py-4 px-4">
      <div className="flex shrink-0 items-center justify-center">
        <Avatar className="h-8 w-8">
          <AvatarImage src="brand/alan/favicon/alan-touch-icon-180x180.png" />
        </Avatar>
      </div>
      <div className="flex h-5 items-end gap-1">
        <div className="h-2 w-2 rounded-full bg-muted-foreground/60 animate-bounce" style={{ animationDelay: '0ms' }}></div>
        <div className="h-2 w-2 rounded-full bg-muted-foreground/60 animate-bounce" style={{ animationDelay: '200ms' }}></div>
        <div className="h-2 w-2 rounded-full bg-muted-foreground/60 animate-bounce" style={{ animationDelay: '400ms' }}></div>
      </div>
    </div>
  )
} 